import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load user from localStorage on initial load
  useEffect(() => {
    const loadUser = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        // Configure axios to use the token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        try {
          // You could add an endpoint to validate the token and get user data
          // For now, we'll just use the stored user info
          const userData = JSON.parse(localStorage.getItem('user'));
          if (userData) {
            setUser(userData);
          }
        } catch (err) {
          console.error('Failed to load user:', err);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        }
      }
      setLoading(false);
    };

    loadUser();
  }, []);

// Register new user
const register = async (userData) => {
  try {
    setLoading(true);
    setError(null);
    // Use the same hardcoded URL approach as the login function
    const res = await axios.post('https://f1-tipping-backend.onrender.com/api/auth/register', userData);
    
    // Save token and user to localStorage
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
    
    // Set authorization header
    axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
    
    setUser(res.data.user);
    return res.data;
  } catch (err) {
    setError(err.response?.data?.message || 'Registration failed');
    throw err;
  } finally {
    setLoading(false);
  }
};

// Login user
const login = async (userData) => {
  try {
    setLoading(true);
    setError(null);
    // Hardcode the URL directly
    const res = await axios.post('https://f1-tipping-backend.onrender.com/api/auth/login', userData);
    
    // Save token and user to localStorage
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.user));
    
    // Set authorization header
    axios.defaults.headers.common['Authorization'] = `Bearer ${res.data.token}`;
    
    setUser(res.data.user);
    return res.data;
  } catch (err) {
    setError(err.response?.data?.message || 'Login failed');
    throw err;
  } finally {
    setLoading(false);
  }
};

  // Logout user
  const logout = () => {
    // Remove token from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    // Remove authorization header
    delete axios.defaults.headers.common['Authorization'];
    
    // Clear user state
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      error,
      register,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};